import { render, staticRenderFns } from "./Corner.vue?vue&type=template&id=dd3c86b8"
import script from "./Corner.vue?vue&type=script&lang=js"
export * from "./Corner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports